import * as routes from "../../api/routes";
import { conventionFetch } from "../../utils/fetchWrapper";

export function getState() {
  return () => {
    return conventionFetch(routes.REQUEST_STATE(), { method: "GET" })
      .prepare()
      .withSuccessHandler(() => {})
      .start();
  };
}



// WEBPACK FOOTER //
// ./src/redux/thunks/orderThunks.js